module.exports = __webpack_public_path__ + "img/liveVideo.fe358f6a.png";